import one from '../Images/w.jpg';
import two from '../Images/indiaa.jpg';
import three from '../Images/c181.jpeg';
import four from '../Images/c5.jpg';

import  web from '../Images/test.jpg';
import six from '../Images/h.jpg';
const IMG="https://i.pinimg.com/564x/7c/e2/c5/7ce2c5f68ea3c408a81a36d79f7ec8cb.jpg"
const IMG1="https://i.pinimg.com/564x/75/0c/03/750c0343e2edc6464eebcb1372c40c22.jpg"
const Data=[
    {
imgsrc:one,
title:"World's Data",
paths:"/world-updates"
    },
    {
        imgsrc:IMG,
        title:"India statewise Regional Data",
        paths:"/RegionalData"
            },
            {
                imgsrc:three,
                title:"India's Medical Colleges",
                paths:"/MedialClg"
                    },
                    {
                        imgsrc:IMG1,
                        title:"India Dashboard",
                        paths:"/dashboard"
                            },
                            {
                                imgsrc:web,
                                title:"COVID Tests Updates",
                                paths:"/TestUpdate"
                                    },
                                    {
                                        imgsrc:six,
                                        title:"Hospital Analysis",
                                        paths:"/Hospital"
                                            }
]
export default Data;
